var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPin16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 8.66671C9.10465 8.66671 10.0001 7.77128 10.0001 6.66671C10.0001 5.56214 9.10465 4.66671 8.00008 4.66671C6.89551 4.66671 6.00008 5.56214 6.00008 6.66671C6.00008 7.77128 6.89551 8.66671 8.00008 8.66671Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.6667C10.6667 12 13.3334 9.61223 13.3334 6.66671C13.3334 3.72119 10.9456 1.33337 8.00008 1.33337C5.05456 1.33337 2.66675 3.72119 2.66675 6.66671C2.66675 9.61223 5.33341 12 8.00008 14.6667Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPin16);
export default __webpack_public_path__ + "static/media/marker-pin-16.364605ee38eec9a6144d39990eb8e12a.svg";
export { ForwardRef as ReactComponent };